import React from 'react';
import 'devextreme/dist/css/dx.light.css';
import TabPanel, {Item} from 'devextreme-react/tab-panel';
import {Link} from "react-router-dom";
import { saveAs } from "file-saver";
import './index.scss';


const SearchAllDetail = ({result}) => {
  console.log(result);
    return (
        <div className="search-all-tab">
             
           
            <TabPanel animationEnabled="true">
               
                <Item title=" محصولات" badge={result.products.length > 0 ? result.products.length : 0} disabled={result.products.length === 0}> 
                    <ul style={{margin:'3%', maxWidth:'63%'}}>
                        {result.products.length > 0 ? Object.keys(result.products).map((prd,l) => 
                            <li key={l}>
                                <Link to={`${process.env.PUBLIC_URL + `/product/${result.products[prd][0].aliasPart}/${result.products[prd][0].content_ContentItem_ContentItemId}`}`}>{result.products[prd][0].content_ContentItem_DisplayText}</Link>
                            </li>
                        ) : null}
                    </ul>
                </Item> 
               
               
                <Item title="وبلاگ"  badge={result.blogs.length > 0 ? result.blogs.length : 0} disabled={result.blogs.length === 0}>
                <ul style={{margin:'3%', maxWidth:'63%'}}>
                        {result.blogs.length > 0 ? Object.keys(result.blogs).map((blg,l) => 
                            <li key={l}>
                                <Link to={`${process.env.PUBLIC_URL + `/blog/${result.blogs[blg][0].aliasPart}/${result.blogs[blg][0].content_ContentItem_ContentItemId}`}`}>{result.blogs[blg][0].content_ContentItem_DisplayText}</Link>
                            </li>
                        ) : null}
                    </ul>
                </Item> 
                
                <Item title="درباره ما"  badge={result.aboutUs.length > 0 ? result.aboutUs.length : 0} disabled={result.aboutUs.length === 0}>
                <ul style={{margin:'3%', maxWidth:'63%'}}>
                        {result.aboutUs.length > 0 ? Object.keys(result.aboutUs).map((abt,l) => 
                            <li key={l}>
                                <Link to={`${process.env.PUBLIC_URL + `/about/${result.aboutUs[abt][0].aliasPart}/${result.aboutUs[abt][0].content_ContentItem_ContentItemId}`}`}>{result.aboutUs[abt][0].content_ContentItem_DisplayText}</Link>
                            </li>
                        ) : null}
                    </ul>
                </Item>
               
                <Item title="اخبار"  badge={result.news.length > 0 ? result.news.length : 0} disabled={result.news.length === 0}>
                {result.news.length > 0 ? Object.keys(result.news).map((n,l) => 
                            <li key={l}>
                                <Link to={`${process.env.PUBLIC_URL + `/news/${result.news[n][0].aliasPart}/${result.news[n][0].content_ContentItem_ContentItemId}`}`}>{result.news[n][0].content_ContentItem_DisplayText}</Link>
                            </li>
                        ) : null}
                    
                </Item> 
            </TabPanel>
               
        </div>
        // </div>
    );
};

export default SearchAllDetail;
